import { render, staticRenderFns } from "./MWReservationSplit.vue?vue&type=template&id=50c05f06&scoped=true&"
import script from "./MWReservationSplit.vue?vue&type=script&lang=js&"
export * from "./MWReservationSplit.vue?vue&type=script&lang=js&"
import style0 from "./MWReservationSplit.vue?vue&type=style&index=0&id=50c05f06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c05f06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCombobox,VDatePicker,VDialog,VIcon,VMenu,VSpacer,VTextField})
